<template>
  <div>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="scanDialogVisible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        width="80%"
        >
        <commonTable
                :tableData="tableData"
                :loading="loading"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                :currentPage="pageNum"
                :total="total"
        >
        <template v-slot:table>
          <template v-if="fetchType === '市区'">
            <el-table-column prop="address" align="center" label="扫码市区">
              <template slot-scope="scope">
                {{scope.row.address? scope.row.address : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="num" align="center" label="扫码次数">
              <template slot-scope="scope">
                {{scope.row.num? scope.row.num : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="peopleNum" align="center" label="扫码人次">
              <template slot-scope="scope">
                {{scope.row.peopleNum? scope.row.peopleNum : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="最近一次扫码客户" width="150">
              <template slot-scope="scope">
                <img :src="scope.row.avatarUrl? scope.row.avatarUrl : defaultAvatar" class="avatar" />
                <span>{{scope.row.nickeName ? scope.row.nickeName : '微信用户'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="最近一次扫码产品">
              <template slot-scope="scope">
              {{scope.row.title? scope.row.title : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="handle" align="center" label="最近一次扫码标识">
              <template slot-scope="scope">
              {{scope.row.handle? scope.row.handle : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="name3" align="center" label="最近一次扫码类型">
              <template slot-scope="scope">
                {{scope.row.source | getSource(scope.row.source)}}
              </template>
            </el-table-column>
             
             <el-table-column prop="time" align="center" label="最近一次扫码时间">
              <template slot-scope="scope">
                {{scope.row.createTime? scope.row.createTime : '---'}}
              </template>
            </el-table-column>
             <el-table-column prop="time" align="center" label="最近一次扫码地点">
              <template slot-scope="scope">
                {{scope.row.detailAddress? scope.row.detailAddress : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="最近一次扫码浏览时长">
              <template slot-scope="scope">
                <span class="timeShowTit" :class="getTimeColor(scope.row.seeTime)" v-if="scope.row.seeTime">
                  {{ getTimeText(scope.row.seeTime)}}
                </span>
                <span v-else>
                  ---
                </span>
              </template>
            </el-table-column>
            
            
          </template>
          <template v-else-if="fetchType === '购买'">
            <el-table-column prop="" align="center" label="页面标识" width="">
                <template slot-scope="scope">
                    <span>{{scope.row.handle ? scope.row.handle : '---'}}</span>
                    <span v-if="scope.row.handle" class="tag-read" :data-clipboard-text="cHandle2"  @click="copyHandle2(scope.row.handle)"><img src="../../../../assets/images/fz.png" /></span>
                </template>
            </el-table-column>
            <el-table-column prop="address" align="center" label="地址" width="">
                <template slot-scope="scope">
                    {{ scope.row.address }}
                </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="客户" width="">
                <template slot-scope="scope">
                    <img :src="scope.row.avatarUrl? scope.row.avatarUrl : defaultAvatar" class="avatar" />
                    <span>{{scope.row.nickeName ? scope.row.nickeName : '微信用户'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="time" align="center" label="购买时间" width="">
                <template slot-scope="scope">
                    <span>{{scope.row.time}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="订单金额" width="">
                <template slot-scope="scope">
                    <span>{{scope.row.orderPrice ? (scope.row.orderPrice/100).toFixed(2) : '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="订单类型" width="">
                <template slot-scope="scope">
                    <span>{{scope.row.orderType==1 ? '码客通名片' :'码客查'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="订单编号" width="">
                <template slot-scope="scope">
                    <span>{{scope.row.orderNo}}</span>
                    <span v-if="scope.row.orderNo" class="tag-read" :data-clipboard-text="cHandle"  @click="copyHandle(scope.row.orderNo)"><img src="../../../../assets/images/fz.png" /></span>
                </template>
            </el-table-column>
          </template>
          <template v-else-if="fetchType === '人次'">
            <el-table-column prop="title" align="center" label="编号">
              <template slot-scope="scope">
                  <span class="serialNumber">{{scope.row.serialNumber? scope.row.serialNumber : '---'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="产品">
              <template slot-scope="scope">
              {{scope.row.title? scope.row.title : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="handle" align="center" label="标识" width="200">
              <template slot-scope="scope">
              {{scope.row.handle? scope.row.handle : '---'}}
              <span class="tag-read" :data-clipboard-text="cHandle"  @click="copyHandle(scope.row.handle)"><img src="../../../../assets/images/fz.png" /></span>
              </template>
            </el-table-column>
            <el-table-column prop="name3" align="center" label="类型">
              <template slot-scope="scope">
                {{scope.row.source | getSource(scope.row.source)}}
              </template>
            </el-table-column>
            <el-table-column prop="avatarUrl" align="center" label="客户">
              <template slot-scope="scope">
                <img :src="scope.row.avatarUrl? scope.row.avatarUrl : defaultAvatar" class="avatar" />
                <span>{{scope.row.nickeName ? scope.row.nickeName : '微信用户'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="time" align="center" label="时间">
              <template slot-scope="scope">
                {{scope.row.time? scope.row.time : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="address" align="center" label="扫码市区">
              <template slot-scope="scope">
                {{scope.row.address? scope.row.address : '---'}}
              </template>
            </el-table-column>
            <el-table-column prop="verificationResult" align="center" label="验证" v-if="logType==2">
              <template slot-scope="scope">
                <span style="color: #f00" v-if="scope.row.verificationResult ==0">验证失败</span>
                <span style="color: #2ABE65" v-if="scope.row.verificationResult ==1">已验证</span>
              </template>
            </el-table-column>
            <el-table-column prop="seeTime" align="center" label="浏览时长">
              <template slot-scope="scope">
                <span class="timeShowTit" :class="getTimeColor(scope.row.seeTime)" v-if="scope.row.seeTime">
                  {{ getTimeText(scope.row.seeTime)}}
                </span>
                <span v-else>
                  ---
                </span>
              </template>
            </el-table-column>
          </template>

        </template>
        </commonTable>
    </el-dialog>
  </div>
</template>

<script>
    import Clipboard from 'clipboard'
    import commonTable from "@/components/common/commonTable";
    import { fetchScanAreaNumDetail, fetchScanPersonNumDetail } from "@/api/scanStatics"
    export default {
        name: "scanDialog",
        components: {
          commonTable
        },
        data() {
            return {
                scanDialogVisible: false,
                defaultAvatar: 'https://apkpic.86122m.com/hstx.png',
                tableData: [],
                loading: false,
                pageSize: 10,
                pageNum: 1,
                total: 1,
                logType: 1,
                isToday: null,
                fetchType: '',
                dialogTitle: '统计',
                cHandle: '',
                cHandle2: '',
            }
        },
        methods: {
         openDialog(type, data, fetchType, isToday) {
           this.logType=type
           this.pageNum = 1
           this.pageSize = 10,
           this.fetchType = fetchType,
           this.isToday = isToday

           this.scanDialogVisible = true
           this.getTableData()
           let title = ''
           if(type === 1) {
            title = '扫码统计'
           }else if( type === 2) {
            title = '验证统计'
           }else if( type === 3) {
            title = '购买统计'
           }else if(type === 4){
            title = '验证统计'
           }
           this.dialogTitle = title
         },
         closeDialog() {
           this.scanDialogVisible = false
         },
         handleSizeChange(num) {
          this.pageSize = num;
          this.pageNum = 1;
          this.getTableData()
         },
         handleCurrentChange(num){
           this.pageNum = num
           this.getTableData()
         },
         getTableData() {
           console.log('get')
           let params={
             pageNum: this.pageNum,
             pageSize: this.pageSize,
             logType: this.logType,
             isToday: this.isToday,
           }
           let v=this
           if(this.fetchType === '人次' || this.fetchType === '购买') {
             fetchScanPersonNumDetail(params).then((res) => {
               if (res.code == 200) {
                  v.tableData = res.data.list
                  v.total = res.data.total
                  v.pageNum = res.data.pageNum
                }
             })
           }else if( this.fetchType === '市区') {
             fetchScanAreaNumDetail(params).then((res) => {
                if (res.code == 200) {
                  v.tableData = res.data.list
                  v.total = res.data.total
                  v.pageNum = res.data.pageNum
                }
             })
           }
         },
         // 获取浏览时长class颜色
          getTimeColor(time){
              let colorArr = ['grey','blue','orange']
              if(time && time < 60){
                  return colorArr[0]
              }else if(time && time >= 60 && time < 600 ) {
                  return colorArr[1]
              }else if(time >= 600) {
                  return colorArr[2]
              }
          },
          getTimeText(time) {
            if(time && time < 600){
              return time + 's'
            }else if(time >= 600) {
              return '600+'
            }else {
              return '-'
            }
          },
          // 复制
          copyHandle(data) {
              this.cHandle = data // data.customPageId
              var clipboard = new Clipboard('.tag-read')
              clipboard.on('success', e => {
                console.log('复制成功')
                
              })
              clipboard.on('error', e => {
                  // 不支持复制
                  console.log('该浏览器不支持复制')
                  // 释放内存
                  // clipboard.listener.destory()
                  this.$message({
                    type: 'warning',
                    message: '该浏览器不支持复制'
                  });
              })
              this.$message({
                type: 'success',
                message: '复制成功'
              });
          },
          copyHandle2(data) {
            this.cHandle2 = data // data.customPageId
            if(!data) {
              return 
            }
            var clipboard = new Clipboard('.tag-read')
            clipboard.on('success', e => {
                console.log('复制成功')
            })
            clipboard.on('error', e => {
                // 不支持复制
                console.log('该浏览器不支持复制')
                // 释放内存
                // clipboard.listener.destory()
                this.$message({
                    type: 'warning',
                    message: '该浏览器不支持复制'
                });
            })
          }
        },
        
        filters: {
          getSource(val) {
            let arr = ['名片', '宣传物料','产品','箱标', '证书']
            //0名片 1宣传物料 2产品 3箱标 4证书
            let str = arr[val]? arr[val] : '--'
            return  str
          }
        },
        mounted() {


        }
    }
</script>

<style scoped>
.avatar{
  width: 32px;
  height: 32px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.timeShowTit {
  font-size: 12px;
  background-color: transparent;
  color: #fff;
  border-radius: 4px;
  height: 25px;
  padding: 3px 8px;
  line-height: 25px;
  margin: auto;
}
.timeShowTit.grey{
      background-color: #EAEFFF;
      color: #4A7AF0;
  }
.timeShowTit.blue{
      background-color: #8EABFF;
      color: #fff;
  }
.timeShowTit.orange{
      background-color: #FFAB52;
      color: #fff;
  }
.serialNumber{
    /* background-color: #8EABFF; */
    color: #333;
    padding: 0 5px;
    border-radius: 4px;
    height: 25px;
    padding: 3px 8px;
    line-height: 25px;
}
.tag-read{
  cursor: pointer;
  vertical-align: bottom;
  margin-left: 3px;
}
.tag-read img {
  vertical-align: sub;
}
</style>
